@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="false" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-fluid-cooler-selections (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-fluid-cooler-selections>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [skus]="skus()" [entityLeadTime]="entityLeadTime" [sfrEntries]="sfrEntries()"
      [configurationLeadTime]="configurationLeadTime()">
    </app-skus-and-prices>
  </div>
</div>
